import { axiosGet } from "../../react_axios/Axios";
import { GET_VENDOR_DOWNLOAD_CENTRE, getVendorDownloadCentreUrl, headers } from '../../utils/constants'


export const getVendorDownloadCentre_action = () => async (dispatch) => {

    try {
        const loginData = JSON.parse(sessionStorage.getItem('loginDataSS'))

        const mapdata = {
            UserID: loginData != null && loginData.UserID != null && loginData.UserID != '' ? loginData.UserID : null,
            ExhibitionID: JSON.parse(sessionStorage.getItem("sessionExhibitionID")),
            RoleID: loginData != null && loginData.RoleID != null && loginData.RoleID != '' ? loginData.RoleID : null,
        }
        console.log("data----------", mapdata)
        const res = await axiosGet(getVendorDownloadCentreUrl, mapdata, headers);

        dispatch({
            type: GET_VENDOR_DOWNLOAD_CENTRE,
            payload: res,
        });

        return Promise.resolve(res);
    } catch (err) {
        return Promise.reject(err);
    }
};
